<template>
	<div>
		<a-page-header style="background: #fff;" title="系统管理"  :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'系统管理'}]}}">
		</a-page-header>
		
		<div class="mainBox">
			<!-- 基本设置 -->
			<div class="searchBox">
				<a-form-model :form="editForm" style="margin-top:40px" :label-col="{ span: 6 }" :wrapper-col="{ span: 10 }">
					<a-form-model-item label="网站名称">
						<a-input placeholder="请填写企业名称" v-model="editForm.webname" />
					</a-form-model-item>
					<a-form-model-item label="LOGO">
						<a-upload name="img" listType="picture-card" class="avatar-uploader" :showUploadList="false" :action="this.$host+'/admin/index.php/admin/qiniu/uploads'"
						 @change="handleChange" v-decorator="['weblogo']">
							<img v-if="editForm.weblogo" :src="editForm.weblogo" alt="avatar" style="width:12.5rem;" />
							<div v-else>
								<a-icon :type="imgloading ? 'loading' : 'plus'" />
								<div class="ant-upload-text">上传</div>
							</div>
						</a-upload>
						<div style="color:#ffa940;">推荐尺寸 300px * 300px 或其他大小的方形图片</div>
					</a-form-model-item>
					<a-form-model-item label="营业时间 早">
						<a-time-picker :value="moment(editForm.opentimeBegin, 'HH:mm')" format="HH:mm" @change="opentimeBeginChange" />
					</a-form-model-item>
					<a-form-model-item label="营业时间 晚">
						<a-time-picker :value="moment(editForm.opentimeEnd, 'HH:mm')" format="HH:mm" @change="opentimeEndChange" />
					</a-form-model-item>
					<a-form-model-item label="客服电话">
						<a-input placeholder="请填写客服电话" v-model="editForm.kfphone" />
					</a-form-model-item>
					<a-form-model-item label="关于我们">
						<a-textarea placeholder="请填写关于我们" :rows="8" v-model="editForm.aboutUs" />
					</a-form-model-item>
					

					<!-- <a-divider>充值设置</a-divider>
					<a-form-model-item label="充值开关">
						<a-switch checked-children="开" un-checked-children="关" v-model="editForm.rechargeOpen"  />
					</a-form-model-item>
					<a-form-model-item label="充值说明">
						<a-textarea placeholder="请填写充值说明" :rows="4" v-model="editForm.rechargeCont" />
					</a-form-model-item> -->
					
					<!-- <a-divider>积分设置</a-divider>
					<a-form-model-item label="积分开关">
						<a-switch checked-children="开" un-checked-children="关" v-model="editForm.integralOpen"  />
					</a-form-model-item>
					<a-form-model-item label="积分说明">
						<a-textarea placeholder="请填写积分说明" :rows="4" v-model="editForm.integralCont" />
					</a-form-model-item> -->
					
					
					<div style="text-align: center;padding: 20px;">
						<a-button type="primary" @click="editFormSubmit">保存</a-button>
					</div>
				</a-form-model>
			</div>

		</div>
	</div>
</template>

<script>
	import https from '../https.js'
	import moment from 'moment';
	export default {
		data() {
			return {
				moment,
				editForm: {
				},
				imgloading:false
			};
		},
		
		created() {
			this.getInfo()
		},
		
		methods: {
			opentimeBeginChange(value){
				this.editForm.opentimeBegin = moment(value).format('HH:mm')
			},
			
			opentimeEndChange(value){
				this.editForm.opentimeEnd = moment(value).format('HH:mm')
			},
			
			getInfo() {
				https.get('/admin/index.php/admin/config/webConfig').then((res) => {
					if (res.data.code == 1) {
						this.editForm = res.data.data
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			editFormSubmit(e) {
				let data = {
					webname: this.editForm.webname,
					weblogo: this.editForm.weblogo,
					opentimeBegin:this.editForm.opentimeBegin,
					opentimeEnd:this.editForm.opentimeEnd,
					kfphone: this.editForm.kfphone,
					aboutUs: this.editForm.aboutUs,
					appid: this.editForm.appid,
					appsecret: this.editForm.appsecret,
					mchid: this.editForm.mchid,
					paykey: this.editForm.paykey,
					rechargeOpen: this.editForm.rechargeOpen,
					rechargeCont: this.editForm.rechargeCont,
					integralOpen: this.editForm.integralOpen,
					integralCont: this.editForm.integralCont,
					smsOpen: this.editForm.smsOpen,
					smsAccessKeyId: this.editForm.smsAccessKeyId,
					smsAccessKeySecret: this.editForm.smsAccessKeySecret,
					smsSign: this.editForm.smsSign
				}
				https.post('/admin/index.php/admin/config/webconfig', data).then((res) => {
					console.log(res.data)
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
			
			handleChange(info) {
				if (info.file.status === 'uploading') {
					this.imgloading = true;
					return;
				}
				if (info.file.status === 'done') {
					// console.log(info)
					this.editForm.weblogo = info.file.response.url;
					this.imgloading = false;
				}
			},
		},
	}
</script>

<style>
</style>
